export const userIdentifier = user => [user?.first_name, user?.last_name].filter(i => i).join(" ") || user.email

export const projectManagerOrGreater = user => user?.role === "project_manager" || user?.role === "admin"
